import React, { useState } from 'react';
import CourierProcessTab1 from './CourierProcessTab1';
import CourierProcessTab2 from './CourierProcessTab2';
import CourierProcessTab3 from './CourierProcessTab3';
import CourierProcessTab4 from './CourierProcessTab4';
import './CourierProcessPage.css'; // For tab styles

const CourierProcessPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { id: 0, label: 'UPLOAD DATA', component: <CourierProcessTab1 /> },
 // { id: 1, label: 'COURIER SERVICE AREA', component: <CourierProcessTab2 /> },
    { id: 1, label: 'COURIER PRIORITY AND STATE', component: <CourierProcessTab3 /> },
   // { id: 3, label: 'TAB 4', component: <CourierProcessTab4 /> },
  ];

  return (
    <div className="courier-process-page">
     {/* <h2>Courier Process</h2> */}
      {/* Tabs Header */}
      <div className="tabs-bar">
        {tabs.map((tab, index) => (
          <div
            key={tab.id}
            className={`tab-item ${activeTab === index ? 'active' : ''}`}
            onClick={() => setActiveTab(index)}
          >
            {tab.label}
          </div>
        ))}
      </div>
      {/* Tab Content */}
      <div className="tab-content">{tabs[activeTab].component}</div>
    </div>
  );
};

export default CourierProcessPage;
